import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class PaymentGuard {
  constructor(
    private router: Router,
    private toastr: ToastrService,
  ) {}

  canActivate(): boolean {
    if (localStorage.getItem('paymentDetails') == null) {
      this.router.navigate(['/']);
      this.toastr.error('Payment details not found');
      return false;
    }
    return true;
  }
}
